module.exports = __webpack_public_path__ + "static/media/img-5.12e6feca.png";